var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ExpedienteService } from '../../services/expediente.service';
import { TasasService } from '../../services/tasas.service';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { AutoCompleteConfig } from '../../common/autocomplete/autocomplete.config';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { KeycloakService } from '../../services/keycloak.service';
var TasasNoExpComponent = (function () {
    function TasasNoExpComponent(_service, _tasService, _expService) {
        this._service = _service;
        this._tasService = _tasService;
        this._expService = _expService;
        this.fecVto = "";
        this.titulo = "Tasas";
        this.tasa = { descripcion: "", fecha: "", importe: "", estado: "", fechaVto: this.fecVto, fechaHecho: "", rep_codigo: "", fechaPago: "", tipo: null, valor: "", complemento: "", multa: "", determinada: "", monto: "", montoI: "", expediente: null };
        this.capt = 0;
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    TasasNoExpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.key = this._service.dataSiteKey();
        this._tasService.getFechaHabil().subscribe(function (response) {
            _this.fecVto = response.fecha;
            _this.tasa.fechaVto = _this.fecVto;
        });
        this._service.findTiposTasasByTipo(3).subscribe(function (response) {
            _this.ttasasList = response;
            _this.autocompleteTasa = new AutoCompleteConfig(_this.ttasasList, 1, "Tipo de Tasas", "id", "descr");
            //this.autocompleteComboTasa.onItemSelected.subscribe((event:any) => { this.onChangeTasa(this.autocompleteComboTasa.selectedItem)});
            //this.autocompleteComboTasa.setDataSource(this.ttasasList);
        });
        this._tasService.findLocalidadesIW().subscribe(function (response) {
            _this.locList = response;
            _this.autocompleteLoc = new AutoCompleteConfig(_this.locList, 1, "Localidad", "id", "desc");
            //this.autocompleteComboLoc.setDataSource(this.locList);            
        });
        this.titulo = this._service.getConfiguracion("TITTASA");
    };
    TasasNoExpComponent.prototype.onClickGenerar = function () {
        var _this = this;
        //console.log("OBJETO " + JSON.stringify(this.tasa));
        if (this.SuccessMessageIsVisible) {
            return;
        }
        this.hideErrorMsg();
        if (this.validate()) {
            this.tasa.rep_codigo = KeycloakService.usr.codRep;
            var fileName = "comprobante_tasasinexp.pdf";
            var a = document.createElement("a");
            document.body.appendChild(a);
            this._tasService.generarCmpSinExp(JSON.stringify(this.tasa)).subscribe(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                _this.showSuccessMessage("La Tasa se ingreso correctamente");
                _this.onFinalizo();
                //this.labelCancelar = "Finalizar";
                //document.getElementById("_printButton").hidden = true;
            }, function (error) {
                _this.showErrorMessage("No se pudo generar el Comprobante");
            });
        }
    };
    TasasNoExpComponent.prototype.validate = function () {
        if (this.tasa.tipo === null) {
            this.showErrorMessage("El Tipo de Tasa no puede ser vacío");
            return false;
        }
        return true;
    };
    TasasNoExpComponent.prototype.onClickLimpiar = function () {
        this.captcha.reset();
        this.capt = 0;
        //this.tipo = {id: 0, descr:"Tipo de tasa", tipo:0,valor:""};
        this.tasa = { descripcion: "", fecha: "", importe: "", estado: "", fechaVto: this.fecVto, fechaHecho: "", rep_codigo: "", fechaPago: "", tipo: null, valor: "", complemento: "", multa: "", determinada: "", monto: "", montoI: "", expediente: null };
        this.hideErrorMsg();
        this.hideSuccessMsg();
        this.childComponents.forEach(function (autocomplete) { return autocomplete.clear(); });
    };
    TasasNoExpComponent.prototype.onFinalizo = function () {
        this.captcha.reset();
        this.capt = 0;
        this.tasa = { descripcion: "", fecha: "", importe: "", estado: "", fechaVto: this.fecVto, fechaHecho: "", rep_codigo: "", fechaPago: "", tipo: null, valor: "", complemento: "", multa: "", determinada: "", monto: "", montoI: "", expediente: null };
        this.childComponents.forEach(function (autocomplete) { return autocomplete.clear(); });
    };
    TasasNoExpComponent.prototype.onChangeLoc = function (event) {
        this.tasa.loc_id = event.id;
    };
    TasasNoExpComponent.prototype.onChangeTasa = function (event) {
        //console.log("tipo de tasa: " + JSON.stringify(event));
        this.tasa.importe = event.valor;
        this.tasa.determinada = event.valor;
        this.tasa.tipo = event;
        // if (this.tasa.tipo.tipo === 0){
        //     this.tasa.valor = this.tasa.tipo.valor + "%";
        //     this.tasa.determinada = (parseFloat(this.tasa.monto) * parseFloat(this.tasa.tipo.valor)).toFixed(2);
        // }else{
        //     this.tasa.monto = this.tasa.tipo.valor;
        // }
        this.setTwoNumberDecimal();
    };
    TasasNoExpComponent.prototype.setTwoNumberDecimal = function () {
        // if (this.tasa.monto !== "")
        //     this.tasa.monto = parseFloat(this.tasa.monto).toFixed(2);
    };
    TasasNoExpComponent.prototype.handleCorrectCaptcha = function (event) {
        try {
            //document.getElementById("generarButton").enabled = true
            this.capt = 1;
            //this.captcha.reset();
        }
        catch (err) {
            //console.log(err); 
        }
    };
    TasasNoExpComponent.prototype.expiredCaptcha = function (event) {
        //console.log("expiro captcha");
        this.capt = 0;
    };
    TasasNoExpComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    TasasNoExpComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    TasasNoExpComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    TasasNoExpComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    return TasasNoExpComponent;
}());
__decorate([
    ViewChildren(AutocompleteComponent),
    __metadata("design:type", QueryList)
], TasasNoExpComponent.prototype, "childComponents", void 0);
__decorate([
    ViewChild(ReCaptchaComponent),
    __metadata("design:type", ReCaptchaComponent)
], TasasNoExpComponent.prototype, "captcha", void 0);
TasasNoExpComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'tasa-noexp',
        templateUrl: 'tasa-noexp.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, TasasService, ExpedienteService])
], TasasNoExpComponent);
export { TasasNoExpComponent };
//# sourceMappingURL=tasa-noexp.component.js.map